import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import Popper from 'popper.js';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { GisToolsService } from '../../../services/gis-tools.service';
import { BaseComponent } from '../../base.component';
var RmsSelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RmsSelectComponent, _super);
    function RmsSelectComponent(_vcr, cdr, gisToolsService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.cdr = cdr;
        _this.gisToolsService = gisToolsService;
        _this.county = null;
        _this.route = null;
        _this.segment = null;
        _this.offset = 0;
        _this.buffer = 100;
        _this.rmsChange = new EventEmitter();
        _this.outsideClickHandler = function () {
            _this.showRmsSelect = false;
        };
        _this.insideClickHandler = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(RmsSelectComponent.prototype, "showRmsSelect", {
        get: function () { return this._showRmsSelect; },
        set: function (value) {
            this._showRmsSelect = value;
            this._showRmsSelect ? this.onShow() : this.onHide();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RmsSelectComponent.prototype, "position", {
        get: function () { return this._position; },
        set: function (value) {
            if (!this._position || value.latitude !== this._position.latitude || value.longitude !== this._position.longitude) {
                this.setRms(value.latitude, value.longitude);
            }
            this._position = value;
        },
        enumerable: true,
        configurable: true
    });
    RmsSelectComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.gisToolsService.getAllCounties('countyCode, name')];
                    case 1:
                        _a.counties = _b.sent();
                        this.rmsSelectPopperRef = new Popper(this.rmsSelectToggleRef.nativeElement, this.rmsSelectContainerRef.nativeElement, {
                            placement: 'bottom-end',
                            positionFixed: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RmsSelectComponent.prototype.onShow = function () {
        this.rmsSelectPopperRef.update();
        window.addEventListener('mousedown', this.outsideClickHandler);
        window.addEventListener('dragstart', this.outsideClickHandler);
        this.rmsSelectToggleRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
        this.rmsSelectContainerRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
    };
    RmsSelectComponent.prototype.onHide = function () {
        window.removeEventListener('mousedown', this.outsideClickHandler);
        window.removeEventListener('dragstart', this.outsideClickHandler);
        this.rmsSelectToggleRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
        this.rmsSelectContainerRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
    };
    RmsSelectComponent.prototype.onCountyChange = function (county) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.county = county;
                        this.route = null;
                        this.segment = null;
                        if (!(county && county.countyCode)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.gisToolsService.getStateRoutesByCounty(county.countyCode, 'countyCode, stateRouteNumber, streetNames')];
                    case 1:
                        _a.routes = _b.sent();
                        this.filteredRoutes = this.routes.filter(function (r) { return r.countyCode === county.countyCode; });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RmsSelectComponent.prototype.onRouteChange = function (route) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.route = route;
                        this.segment = null;
                        if (!(route && route.stateRouteNumber)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.gisToolsService.getSegmentsByCountyAndRoute(this.county.countyCode, route.stateRouteNumber, 'countyCode, stateRouteNumber, segmentNumber, streetName, segmentLength')];
                    case 1:
                        _a.segments = _b.sent();
                        this.filteredSegments = this.segments.filter(function (s) {
                            return s.countyCode === route.countyCode && s.stateRouteNumber === route.stateRouteNumber && s.stateRouteNumber === route.stateRouteNumber;
                        });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RmsSelectComponent.prototype.onSegmentChange = function (segment) {
        this.segment = segment;
        this.setOffset(0);
    };
    RmsSelectComponent.prototype.onOffsetChange = function (offset) {
        this.setOffset(offset);
    };
    RmsSelectComponent.prototype.setOffset = function (offset) {
        if (!offset || Number.isNaN(offset) || offset < 0) {
            this.offset = 0;
        }
        else if (offset > this.segment.segmentLength) {
            this.offset = this.segment.segmentLength;
        }
        else {
            this.offset = offset;
        }
        this.rmsChange.emit({
            countyCode: this.county.countyCode,
            stateRouteNumber: this.route.stateRouteNumber,
            segmentNumber: this.segment.segmentNumber,
            offset: this.offset.toString()
        });
    };
    RmsSelectComponent.prototype.setRms = function (latitude, longitude) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rmsOffsets, countyChange, routeChange;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsService.getOffsetForLatLong(latitude, longitude, this.buffer, 'countyCode, stateRouteNumber, segmentNumber, offset')];
                    case 1:
                        rmsOffsets = _a.sent();
                        if (!(rmsOffsets && rmsOffsets.length > 0)) return [3 /*break*/, 6];
                        countyChange = !this.county || this.county.countyCode !== rmsOffsets[0].countyCode;
                        routeChange = !this.route || this.route.stateRouteNumber !== rmsOffsets[0].stateRouteNumber;
                        if (!countyChange) return [3 /*break*/, 3];
                        this.county = this.counties.find(function (c) { return c.countyCode === rmsOffsets[0].countyCode; });
                        return [4 /*yield*/, this.onCountyChange(this.county)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(countyChange || routeChange)) return [3 /*break*/, 5];
                        this.route = this.filteredRoutes.find(function (r) { return r.stateRouteNumber === rmsOffsets[0].stateRouteNumber; });
                        return [4 /*yield*/, this.onRouteChange(this.route)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.segment = this.filteredSegments.find(function (s) { return s.segmentNumber === rmsOffsets[0].segmentNumber; });
                        this.offset = rmsOffsets[0].offset;
                        this.cdr.detectChanges();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], RmsSelectComponent.prototype, "showRmsSelect", null);
    return RmsSelectComponent;
}(BaseComponent));
export { RmsSelectComponent };
